import { apiClient } from "./../api/client";
import { API_URLS } from "../api/config";
const { appVersion } = API_URLS;

export const listAppVersions = (payload) => {
  return apiClient({ url: appVersion.list, data: payload })
    .then((res) => res?.data===null?{}:res?.data===null?{}:res?.data===null?{}:res?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const createAppVersion = (payload) => {
  return apiClient({ url: appVersion.create, data: payload })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err?.data?.message);
    });
};

export const updateAppVersion = (payload) => {
  return apiClient({
    url: appVersion.update + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.data?.message || "Can't update record.");
    });
};

export const softDeleteAppVersion = (payload) => {
  return apiClient({
    url: appVersion.softdelete + payload.id,
    data: payload,
    method: "PUT",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};

export const deleteAppVersion = (payload) => {
  return apiClient({
    url: appVersion.delete + payload.id,
    data: payload,
    method: "DELETE",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getAppVersionCount = () => {
  return apiClient({ url: appVersion.count })
    .then((res) => res.data?.totalRecords || 0)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getAppVersionAggregate = (payload) => {
  return apiClient({ url: appVersion.aggregation, data: payload })
    .then((res) => res.data?.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getAppVersionById = (payload) => {
  return apiClient({
    url: appVersion.singlerecord + payload,
    data: { query: { isActive: true, isDeleted: false } },
    method: "GET",
  })
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const softDeleteMultipleAppVersion = (payload) => {
  return apiClient({
    url: appVersion.multisoftdelete,
    data: payload,
    method: "PUT",
  })
    .then((res) => res)
    .catch((err) => {
      throw new Error(err);
    });
};
